import React, { FunctionComponent } from 'react'

import contactUsSuccess from '../../assets/contact_us_success.png'
import { tID } from '../../utils'
import { Image } from '../image/Image'

interface ContactUsSuccessIllustrationProps {
  size?: number
}

export const ContactUsSuccessIllustration: FunctionComponent<ContactUsSuccessIllustrationProps> = ({
  size = 196,
  ...props
}) => {
  return (
    <Image
      source={contactUsSuccess}
      style={{ width: size, height: size }}
      contentFit='contain'
      {...props}
      accessibilityIgnoresInvertColors
      testID={tID('ContactUsSuccessIllustration')}
    />
  )
}
